import { Button, Checkbox, Col, notification, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { employeeService, roleService } from "../../../../services";
import { useNavigate, useParams } from "react-router-dom";

function Permissions() {

    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false)

    const [permissions, setPermissions] = useState([]);
    const [modulePermissions, setModulePermissions] = useState({});
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [roleName, setRoleName] = useState('');

    const handleSelectAll = (record) => {
        const allSelected = selectedPermissions[record.key]?.length === record.Permissions.length;

        setSelectedPermissions((prev) => ({
            ...prev,
            [record.key]: allSelected ? [] : record.Permissions.map((perm) => perm.name),
        }));
    };

    // Handle individual checkbox selection
    const handleCheckboxChange = (recordKey, permName) => {
        setSelectedPermissions((prev) => {
            const selected = prev[recordKey] || [];
            const isSelected = selected.includes(permName);

            return {
                ...prev,
                [recordKey]: isSelected
                    ? selected.filter((item) => item !== permName)
                    : [...selected, permName],
            };
        });
    };

    const columns = [
        {
            title: "Select All",
            dataIndex: "Select",
            width: 150,
            key: "Select",
            render: (_, record) => (
                <Checkbox
                    checked={selectedPermissions[record.key]?.length === record.Permissions.length}
                    onChange={() => handleSelectAll(record)}
                />
            ),
        },
        {
            title: "Module",
            dataIndex: "Module",
            width: 200,
            key: "Module",
        },
        {
            title: "Permissions",
            dataIndex: "Permissions",
            width: 400,
            key: "Permissions",
            render: (_, record) => (
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {record.Permissions.map((perm) => (
                        <Checkbox
                            key={perm.name}
                            checked={selectedPermissions[record.key]?.includes(perm.name) || false}
                            onChange={() => handleCheckboxChange(record.key, perm.name)}
                        >
                            {perm.title}
                        </Checkbox>
                    ))}
                </div>
            ),
        },
    ];

    const fetchRolePermissions = async () => {
        const response = await roleService.view(id);
        if (response?.success ?? false) {
            setRoleName(response.data.title)
            const rolePermissions = response.data.permissions.map((perm) => perm.name);
            // Set selected permissions based on API response
            setSelectedPermissions((prev) => {
                const updatedPermissions = {};

                Object.entries(modulePermissions).forEach(([module, perms], index) => {
                    updatedPermissions[index.toString()] = perms
                        .filter((perm) => rolePermissions.includes(perm.name)) // Check if in API response
                        .map((perm) => perm.name); // Store permission name
                });

                return updatedPermissions;
            });
        }
    }

    const makeModules = () => {
        const groupedPermissions = {};

        permissions?.forEach(({ name, title }) => {
            const parts = name.split("_");
            if (parts.length > 1) {
                const action = parts[0].toLowerCase();
                let module = parts.slice(1).join("_").toLowerCase();
                module = module.replace(/s$/, "");
                module = module.charAt(0).toUpperCase() + module.slice(1); // Capitalize module name

                if (!groupedPermissions[module]) {
                    groupedPermissions[module] = [];
                }

                groupedPermissions[module].push({ action, title, name });
            }
        });

        setModulePermissions(groupedPermissions);
    };

    // Convert modulePermissions object into table data format
    const data = Object.entries(modulePermissions).map(([module, permissions], index) => ({
        key: index.toString(),
        Module: module.replace(/_/g, " "),
        Permissions: permissions,
    }));

    const handleSubmit = async () => {
        setLoading(true);
        const allPermissions = Object.values(selectedPermissions).flat();

        const formattedData = {
            permissions: allPermissions,
        };

        const response = await roleService.assignPermissions(id, formattedData);
        setLoading(false);
        if (response?.success ?? false) {
            notification.success({
                message: "Permissions assigned."
            })
            navigate('/staff/role')
        }
    };

    const initialize = async () => {
        setInitialLoading(true);
        const response = await employeeService.fetchPermissions();
        setInitialLoading(false);
        if (response?.success ?? false) {
            setPermissions(response.data);
        }
    };

    useEffect(() => {
        initialize();
        makeModules();
    }, []);

    useEffect(() => {
        if (permissions?.length > 0) {
            makeModules();
        }
    }, [permissions]);

    useEffect(() => {
        if (Object.keys(modulePermissions).length > 0) {
            fetchRolePermissions();
        }
    }, [modulePermissions]);

    return (
        <div>
            <Row
                gutter={24}
                style={{
                    border: "1px solid #D9D9D9",
                    backgroundColor: "#FFFFFF",
                    padding: "12px",
                    borderRadius: "8px",
                }}
            >
                <Col span={12} style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    <span className="text-primary capitalize"> {roleName}</span> Manage Permissions
                </Col>
                <Col span={24} style={{ marginTop: "20px" }}>
                    <Table dataSource={data} columns={columns} pagination={false} loading={initialLoading} />
                </Col>
                <Col span={24} style={{ marginTop: 15, textAlign: "center" }}>
                    <Button type="primary" onClick={handleSubmit} style={{ width: "20%" }} loading={loading}>
                        Submit
                    </Button>
                </Col>
            </Row>
        </div>
    );
}

export default Permissions;
